import type { QueryClient, QueryFilters } from '@tanstack/react-query';

/**
 * Refresh queries after a write: cancel any in-flight fetch first, then
 * invalidate. Use this instead of a bare `invalidateQueries` everywhere.
 *
 * Why: TanStack Query (query-core `Query.fetch`) only cancels-and-refetches
 * an in-flight fetch when the query already HAS data. During a query's first
 * load it reuses the in-flight promise — so a write that commits after that
 * first fetch was answered is never shown: the invalidation resolves with the
 * pre-write result. Cancelling first makes the invalidation start a fresh
 * fetch. Found on the Team page (an invite during the list's first load never
 * appeared; CI 2026-10-01).
 */
export async function cancelThenInvalidate(queryClient: QueryClient, ...filters: QueryFilters[]): Promise<void> {
  await Promise.all(filters.map((f) => queryClient.cancelQueries(f)));
  await Promise.all(filters.map((f) => queryClient.invalidateQueries(f)));
}
